import {
  useGetConvertResultSettlementStatisticsExpenditureNatures,
  useGetConvertResultSettlementStatisticsExpenditurePurposes,
  useGetConvertResultSettlementStatisticsRevenuePurposes,
} from '@/entities/settlementstatisticsconverter/api/generated/api';
import type { MasterType } from '@/entities/settlementstatisticsconverter/lib/master-type';

/**
 * マスタ種別に応じたデータ取得フック
 * 3種類のAPIを切り替え、リーフ判定フラグを付与したデータを返す
 */
export const useMasterData = ({
  resultId,
  masterType,
}: {
  resultId: string;
  masterType: MasterType;
}) => {
  const { data: expenditurePurposes, isLoading: isLoadingPurposes } =
    useGetConvertResultSettlementStatisticsExpenditurePurposes(resultId, {
      query: { enabled: masterType === 'expenditure_purpose' },
    });

  const { data: expenditureNatures, isLoading: isLoadingNatures } =
    useGetConvertResultSettlementStatisticsExpenditureNatures(resultId, {
      query: { enabled: masterType === 'expenditure_nature' },
    });

  const { data: revenuePurposes, isLoading: isLoadingRevenue } =
    useGetConvertResultSettlementStatisticsRevenuePurposes(resultId, {
      query: { enabled: masterType === 'revenue_purpose' },
    });

  const dataMap = {
    expenditure_purpose: expenditurePurposes,
    expenditure_nature: expenditureNatures,
    revenue_purpose: revenuePurposes,
  } as const;

  const isLoadingMap = {
    expenditure_purpose: isLoadingPurposes,
    expenditure_nature: isLoadingNatures,
    revenue_purpose: isLoadingRevenue,
  } as const;

  return { data: dataMap[masterType] ?? [], isLoading: isLoadingMap[masterType] };
};
